import styled, { css } from 'styled-components';
import { getSchemaVariant } from '../../../foundation/theme/palette.utils';
import { getRadius } from '../../../foundation/theme/shape.utils';
import { getSpace } from '../../../foundation/theme/space.utils';
import { ICONBUTTON_PADDING_SIZES } from './IconButton.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const IconButtonRoot = styled.button `
  ${({ mode, schema, size, theme, variant, isRound }) => {
    const { default: defaultColor, disabled: disabledColor, focus: focusColor, hover: focusHover, pressed: pressedHover } = getSchemaVariant({ mode, schema, theme, variant });
    return css `
      /* Box model */
      align-items: center;
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;

      /* Colors */
      background-color: ${defaultColor.background};
      border: 2px solid ${defaultColor.border};
      color: ${defaultColor.foreground};

      svg {
        height: 18px;
        color: ${defaultColor.foregroundAlt};
      }

      /* Radius */
      border-radius: ${isRound ? `100%` : getRadius(theme, 'm')};

      /* Spacing */
      padding-bottom: ${getSpace(ICONBUTTON_PADDING_SIZES[size].vertical)};
      padding-left: ${getSpace(ICONBUTTON_PADDING_SIZES[size].horizontal)};
      padding-right: ${getSpace(ICONBUTTON_PADDING_SIZES[size].horizontal)};
      padding-top: ${getSpace(ICONBUTTON_PADDING_SIZES[size].vertical)};

      /* Misc */
      cursor: pointer;

      /* Status: Disabled. */
      &:disabled {
        background-color: ${disabledColor.background};
        border: 2px solid ${disabledColor.border};
        color: ${disabledColor.foreground};

        svg {
          color: ${disabledColor.foregroundAlt};
        }
      }

      /* Status: Focus. */
      &:focus {
        background-color: ${focusColor.background};
        border: 2px solid ${focusColor.border};
        color: ${focusColor.foreground};

        svg {
          color: ${focusColor.foregroundAlt};
        }
      }

      /* Status: Hover. */
      &:hover {
        background-color: ${focusHover.background};
        border: 2px solid ${focusHover.border};
        color: ${focusHover.foreground};

        svg {
          color: ${focusHover.foregroundAlt};
        }
      }

      /* Status: Pressed. */
      &:active {
        background-color: ${pressedHover.background};
        border: 2px solid ${pressedHover.border};
        color: ${pressedHover.foreground};

        svg {
          color: ${pressedHover.foregroundAlt};
        }
      }
    `;
}}
`;
//# sourceMappingURL=IconButton.styled.js.map